import catalogue from "@/data/hero-abilities.json";
import type { Hero } from "@/types/cloud-data";

export interface HeroAbility {
  id: string;
  title: string;
  saveIndex: number;
  maxLevel: number;
  icon: string | null;
}
interface HeroAbilities {
  name: string;
  skills: HeroAbility[];
  masteries: HeroAbility[];
}
export interface SavedHeroAbility extends HeroAbility {
  level: number | null;
  equipped: boolean;
}
const heroes: Record<string, HeroAbilities> = catalogue;

// MenuSkills uses skillUnlockOrder to map display order to the saved skill index.
// Masteries have a separate save array; unused skillLevels[8..15] are not masteries.
export function heroAbilities(hero: Hero): { skills: SavedHeroAbility[]; masteries: SavedHeroAbility[] } | null {
  const reference = heroes[String(hero.HERO)];
  if (!reference) return null;
  const map = (rows: HeroAbility[], levels: unknown, active: boolean): SavedHeroAbility[] => rows.map(row => {
    const level: unknown = Array.isArray(levels) ? levels[row.saveIndex] : undefined;
    return { ...row, level: typeof level === "number" && Number.isFinite(level) ? level : null,
      equipped: active && Array.isArray(hero.skillSlot) && hero.skillSlot.includes(row.saveIndex) };
  });
  return { skills: map(reference.skills, hero.skillLevels, true), masteries: map(reference.masteries, hero.masteryLvl, false) };
}
